<template>
    <v-container class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-stepper v-model="step" class="elevation-0">
                    <template>
                        <v-stepper-header class="elevation-0 stepperHeader">
                            <v-divider></v-divider>
                            <v-stepper-step
                                :rules="[
                                    () =>
                                        getStorageAttachmentsItems.errors
                                            .stepOne.validation,
                                ]"
                                editable
                                step="1"
                                >{{
                                    $t('attachments:addFromStorage')
                                }}</v-stepper-step
                            >
                            <v-divider></v-divider>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <Separator
                                            :text="
                                                $t('attachments:addFromStorage')
                                            "
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select
                                            :items="getStorageTable.items"
                                            multiple
                                            v-model="
                                                getStorageAttachmentsItems.items
                                            "
                                            :label="`${$t(
                                                'attachments:chooseFiles'
                                            )}*`"
                                            item-value="_id"
                                            return-object
                                            :error-messages="
                                                getStorageAttachmentsItems
                                                    .errors.stepOne.files
                                            "
                                        >
                                            <template
                                                v-slot:selection="selection"
                                            >
                                                <span>{{
                                                    selection.item.name
                                                }}</span>
                                                <span class="ml-1">{{
                                                    selection.item.lastname
                                                }}</span>
                                                <span
                                                    class="mr-1"
                                                    v-if="
                                                        getStorageModal.users
                                                            .length > 1
                                                    "
                                                    >,</span
                                                >
                                            </template>
                                            <template v-slot:item="item">
                                                <div class="doubleLine">
                                                    <span class="firstLine">{{
                                                        item.item.name
                                                    }}</span>
                                                    <span class="secondLine">{{
                                                        item.item.description
                                                    }}</span>
                                                </div></template
                                            >
                                        </v-select>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                        </v-stepper-items>
                    </template>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    i18nOptions: { namespaces: ['global'] },
    data() {
        return {
            date: '',
            step: 1,
            editable: true,
        }
    },

    computed: {
        ...mapGetters([
            'getStorageErrors',
            'getStorageModal',
            'getStorageTable',
            'getStorageAttachmentsItems',
        ]),
    },
}
</script>

<style lang="sass" scoped>
.firstLine
    font-size: 14px !important

.secondLine
    color: gray
</style>
